import AnniversaryWeb from "../assets/images/webps/anniversary-event-service.webp";
import Anniversary from "../assets/images/others/anniversary-event-service.jpg";
import BirthdayWeb from "../assets/images/webps/birthday-event-service.webp";
import Birthday from "../assets/images/others/birthday-event-service.jpg";
import CorporateWeb from "../assets/images/webps/corporate-event-service.webp";
import Corporate from "../assets/images/others/corporate-event-service.jpg";
import BabyshowerWeb from "../assets/images/webps/babyshower-event-service.webp";
import Babyshower from "../assets/images/others/babyshower-event-service.jpg";
import BacheloretteWeb from "../assets/images/webps/bachelorette-event-service.webp";
import Bachelorette from "../assets/images/others/bachelorette-event-service.jpg";
import ProposalsWeb from "../assets/images/webps/proposalas-event-service.webp";
import Proposals from "../assets/images/others/proposalas-event-service.jpg";
import HighTeaPartyWeb from "../assets/images/webps/HighteaParties-event-services.webp";
import HighTeaParty from "../assets/images/others/HighteaParties-event-services.jpg";
import AwardEventWeb from "../assets/images/webps/award-event-service.webp";
import AwardEvent from "../assets/images/others/award-event-service.jpg";
import HouseWarmingPartiesWeb from "../assets/images/webps/HouseWarmingParties-event-service.webp";
import HouseWarmingParties from "../assets/images/others/HouseWarmingParties-event-service.jpg";
import LunchEventPartiesWeb from "../assets/images/webps/LaunchEvents-event-services.webp";
import LunchEventParties from "../assets/images/others/LaunchEvents-event-services.jpg";
import TraditionalEventWeb from "../assets/images/webps/tranditional-event-service.webp";
import TraditionalEvent from "../assets/images/others/tranditional-event-service.jpg";
import VirtualEventWeb from "../assets/images/webps/virtual-event-service.webp";
import VirtualEvent from "../assets/images/others/virtual-event-service.jpg";

export const servercesData = [
  {
    id: 101,
    name: "Birthdays",
    description:
      "You are starting a new year of your life and we make sure that it's beautiful, unique, and bliss.",
    imgWeb: BirthdayWeb,
    imgNorm: Birthday,
  },
  {
    id: 102,
    name: "Corporate Events",
    description: "Formal but classy and enjoyable, that is how we set it up.",
    imgWeb: CorporateWeb,
    imgNorm: Corporate,
  },
  {
    id: 103,
    name: "Baby Shower",
    description:
      "New beginning, new responsibilities, and tons of love. We make sure that we bring a lot of grace to your special event through our ideas and planning.",
    imgWeb: BabyshowerWeb,
    imgNorm: Babyshower,
  },
  {
    id: 104,
    name: "Bachelorette",
    description:
      "Well! Well! Well! It is your last day of being single, so it definitely should be a blast with fun and games, and booze. We make sure that we make your last single night the most memorable.",
    imgWeb: BacheloretteWeb,
    imgNorm: Bachelorette,
  },
  {
    id: 105,
    name: "Proposals",
    description:
      "He/She said YES! You definetly want your proposal to be filled with love, lights and joy. Be it in a restaurant or just in your car. We make your event the most memorable by planning the best ideas and delivering it to you.",
    imgWeb: ProposalsWeb,
    imgNorm: Proposals,
  },
  {
    id: 106,
    name: "High Tea Parties",
    description:
      "You need a day where your spend time with your family, friends, and loved ones.Girls definitely enjoy their gossip and kitties over a nice high tea party. So, here we are giving you the best plans for your day to just sit and relax with your loved ones with a cup of tea.",
    imgWeb: HighTeaPartyWeb,
    imgNorm: HighTeaParty,
  },
  {
    id: 107,
    name: "Award Events",
    description: "That's the thing about awards - it's for the people who do all the hard work behind the scenes. An award is just a clap at them. We make sure that your Award will become your memory.",
    imgWeb: AwardEventWeb,
    imgNorm: AwardEvent,
  },
  {
    id: 108,
    name: "Anniversaries",
    description:
      "It's such a beautiful time when you realise you've spent ample amount of time together and made life more successful. So we at EventEmporium will make sure you get the most wonderful time with love, creativity and transparency.",
    imgWeb: AnniversaryWeb,
    imgNorm: Anniversary,
  },
  {
    id: 109,
    name: "HouseWarming Parties",
    description: "There is lot of struggle and hardwork just to make that one house you can call home. We will make sure that we deliver you an event that will fill your new home with beautiful memories.",
    imgWeb: HouseWarmingPartiesWeb,
    imgNorm: HouseWarmingParties,
  },
  {
    id: 110,
    name: "Launch Event Parties",
    description: "Setting up something new? You are probably having a tons of things on your plate. Although, the most important launch event should be unique and create a good marketing for you. We are here and everyting would be taken care of so no worries.",
    imgWeb: LunchEventPartiesWeb,
    imgNorm: LunchEventParties,
  },
  {
    id: 111,
    name: "Traditional Events",
    description: "Festival remind us how important it is to keep our families together as all cousins gather together to have memorable time. Be it Ganesh Chatuthi, Diwali, Eid or Christmas. We are here to create most memorable event that you could think at any point.",
    imgWeb: TraditionalEventWeb,
    imgNorm: TraditionalEvent,
  },
  {
    id: 112,
    name: "Virtual Events",
    description: "We make sure your event is a hit even when it is done virtually.",
    imgWeb: VirtualEventWeb,
    imgNorm: VirtualEvent,
  },
];
